module.exports = __webpack_public_path__ + "media/scanner/keyboard-131a915e.png";